export const NUMBER_GMV_BILLING_HISTORY_ROW_PER_PAGE = 10;

export const COLUMN_GMV_BILLING_HISTORY_OPTIONS = [
  { label: 'tableHeading01', value: 'chargeDate', tooltip: false, textAlign: 'center' },
  { label: 'tableHeading02', value: 'status', tooltip: false, textAlign: 'left' },
  { label: 'tableHeading03', value: 'gmv', tooltip: 'tableHeading03_Tooltip', textAlign: 'center' },
  { label: 'tableHeading04', value: 'plan', tooltip: false, textAlign: 'right' },
  {
    label: 'tableHeading05',
    value: 'gmvPlanLimit',
    tooltip: 'tableHeading05_Tooltip',
    textAlign: 'right'
  },
  { label: 'tableHeading06', value: 'pricing', tooltip: false, textAlign: 'right' },
  {
    label: 'tableHeading07',
    value: 'exceedGMV',
    tooltip: 'tableHeading07_Tooltip',
    textAlign: 'right'
  },
  {
    label: 'tableHeading08',
    value: 'overageFee',
    tooltip: 'tableHeading08_Tooltip',
    textAlign: 'right'
  },
  { label: 'tableHeading09', value: 'total', tooltip: false, textAlign: 'right' },
  { label: 'tableHeading10', value: 'action', tooltip: false, textAlign: 'center' }
];

export const NUMBER_DAYS_LIMIT = 365;

export const DATE_RANGE = [
  {
    value: 'last90Days',
    label: 'AdminHTML.SubscriptionV5.GMVBillingHistory.filterDays_3Months',
    days: 90
  },
  {
    value: 'last180Days',
    label: 'AdminHTML.SubscriptionV5.GMVBillingHistory.filterDays_6Months',
    days: 180
  },
  {
    value: 'custom',
    label: 'AdminHTML.SubscriptionV5.GMVBillingHistory.filterDays_custom',
    days: 0
  }
];
